import { render, staticRenderFns } from "./ScrollShortcut.vue?vue&type=template&id=081c8e8f&scoped=true"
import script from "./ScrollShortcut.vue?vue&type=script&lang=js"
export * from "./ScrollShortcut.vue?vue&type=script&lang=js"
import style0 from "./ScrollShortcut.vue?vue&type=style&index=0&id=081c8e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c8e8f",
  null
  
)

export default component.exports